// src/utils/formlinks.js
const formTypePrefixes = {
  // Keeping old mappings for backward compatibility
  'DA_Arrears': 'daArrearsForm/daArrears-result',
  'Arrears_Seventh': 'arrearesSeventh/arrears_seventh_result',
  'Sr_Placement': 'srPlacementForm/srPlacement-result',
  'Senior Pension Case': 'pensionsr/pensionCase-result',
  'Senior College Scale Fixation': 'srScaleFixation/srScaleFixation-result',
  'Pension Case High School': 'pensionHighSchool/pensionCase-result',
  'New Appointment HS': 'hsNewAppointment/hsNewAppointment-result'
};

export const generateFormLink = (formType, uniqueFormId) => {
  const prefix = formTypePrefixes[formType];
  const baseUrl = process.env.REACT_APP_FRONTEND_URL || window.location.origin;

  if (!prefix || !uniqueFormId) return null;

  return `${baseUrl}/${prefix}/${uniqueFormId}`;
};